module.exports = __webpack_public_path__ + "media/images/slide_1-dbbf784602971d95bc7717bdcf00d440.png";